.recipient-name {
    max-width: 300px;
    overflow: hidden;
}

.contact-info {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.loading {
    height: 17px;
    background-color: white;
    width: 100%;
}
